import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 24px 0 0 0;
  border: 1px solid var(--section-ebony-border-color, var(--ebony));
  pre {
    code {
      padding-left: 4px;
      background: inherit;
    }
  }
`;

export const Header = styled.header`
  display: flex;
  margin: 0;
  padding: 0 16px;
  background-color: var(--header-ebony-background-color, var(--ebony));
  line-height: 40px;
  h1 {
    margin: 0;
    font-size: 12px;
    color: var(--header-snow-color, var(--snow));
    font-family: var(--ff-mono), monospace;
  }
`;

export const Buttons = styled.div`
  display: flex;
  align-self: center;
  margin: 0 0 0 auto;
`;

export const Button = styled.div<{ active: boolean }>`
  width: 32px;
  height: 32px;
  cursor: pointer;
  background: none;
  text-align: center;
  background: ${({ active }) =>
    active ? "var(--mode-bg-neutral-inverse)" : "none"};
  color: ${({ active }) =>
    active
      ? "var(--mode-text-neutral-inverse-strong)"
      : "var(--mode-text-neutral-inverse-weak)"};

  svg {
    max-width: 18px;
    max-height: 20px;
  }

  &:hover {
    background: var(--mode-bg-neutral-inverse);
    color: var(--icon-snow-fill, var(--snow));
  }
`;
